import type { ApiPlansPayload, Plan, PlanName, PlanPayload } from "@/types";

export function mapPlansToAvailablePlanNames(plans: Plan[]): PlanName[] {
  const planNames: Set<PlanName> = new Set<PlanName>();

  for (const plan of plans) {
    if (plan.name === "practices_monthly") {
      planNames.add("practices_yearly");
    } else if (
      plan.name === "self_paced" ||
      plan.name === "courses" ||
      plan.name === "trainings" ||
      plan.name === "practices_yearly" ||
      plan.name === ""
    ) {
      planNames.add(plan.name);
    }
  }
  return Array.from(planNames);
}

const PLAN_NAME_LABELS: Record<string, string> = {
  self_paced: "Self-paced course",
  courses: "Course materials",
  trainings: "Teacher materials",
  practices_monthly: "Practices (monthly)",
  practices_yearly: "Practices (yearly)",
};

/** Turns a raw plan name (e.g. "self_paced") into a friendly label for display. */
export function mapPlanNameToLabel(name: string): string {
  return PLAN_NAME_LABELS[name] ?? name;
}

export function transformPlanNamesToApiFormat(
  planNames: PlanName[],
): ApiPlansPayload {
  const plans: PlanPayload[] = planNames.map((name) => ({
    name,
  }));
  return { plans };
}
